// 买贵赔

export default [
    {
        path: '/indemnity',
        redirect: { name: 'IndemnityIndex' },
    },
    {
        path: '/indemnity/index',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnity/index.vue'),
        name: 'IndemnityIndex',
        meta: {
            title: '',
        },
    },
    {
        path: '/indemnity/record',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnity/record.vue'),
        name: 'IndemnityRecord',
        meta: {
            title: '赔付记录',
        },
    },
    {
        path: '/indemnity/list',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnity/list.vue'),
        name: 'IndemnityList',
        meta: {
            title: '申请赔付',
        },
    },
    {
        path: '/indemnity/detail',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnity/detail.vue'),
        name: 'IndemnityDetail',
        meta: {
            title: '申请赔付',
        },
    },
    {
        path: '/indemnity/success',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnity/success.vue'),
        name: 'IndemnitySuccess',
        meta: {
            title: '申请成功',
        },
    },
    {
        path: '/indemnity/rules',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnity/rules.vue'),
        name: 'IndemnityRules',
        meta: {
            title: '详细规则',
        },
    },
];
